import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { gql } from 'apollo-boost';
import { Mutation, withApollo } from 'react-apollo';
import { Formik } from 'formik';
import TankForm from '~/components/tankForm/tankForm';
import { tankValidationSchema } from '../../validation/tank';

export const createTanksMutation = gql`
  mutation createTank($breweryId: Int!, $name: String!, $notes: String, $volume: Int!, $type: TankType!) {
    createTank(breweryId: $breweryId, name: $name, notes: $notes, volume: $volume, type: $type) {
      id
      name
      breweryId
      notes
      volume
      type
    }
  }
`;

export const TankCreateForm = ({ brewery, history, client }) => (
  <div className="content">
    <Mutation mutation={createTanksMutation}>
      {createTank => (
        <Formik
          initialValues={{
            type: 'BREW_TANK'
          }}
          validateOnChange={false}
          validateOnBlur={false}
          validationSchema={tankValidationSchema}
          onSubmit={async (values, { setErrors, setSubmitting }) => {
            try {
              const newTank = await createTank({
                variables: {
                  ...values,
                  breweryId: brewery.id
                },
                refetchQueries: ['tanks']
              });
              history.push(`/tanks?new=${newTank.data.createTank.name}`);
            } catch (err) {
              setErrors({
                unknown: 'An unknown error occured'
              });
              setSubmitting(false);
            }
          }}
          render={TankForm}
        />
      )}
    </Mutation>
  </div>
);

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(withRouter(withApollo(TankCreateForm)));



// WEBPACK FOOTER //
// ./src/containers/tankCreate/tankCreate.jsx